export default "__VITE_ASSET__CsoGDuxl__"